import { takeLatest, all } from 'redux-saga/effects';
import { LoginTypes } from '../redux/LoginRedux';
import { RegisterTypes } from '../redux/RegisterRedux';
import { ForgotPasswordTypes } from '../redux/ForgotPasswordRedux';
import { GetChildrenTypes } from '../redux/GetChildrenRedux';
import { GetMeTypes } from '../redux/GetMeRedux';
import { LogoutTypes } from '../redux/LogoutRedux';
import { AttemptGoalTypes } from '../redux/AttemptGoalRedux';
import { GetCalendarEventsTypes } from '../redux/GetCalendarEventsRedux';
import { GetAnnouncementsTypes } from '../redux/GetAnnouncementsRedux';
import { LeaveTypes } from '../redux/LeaveRedux';
import { UpdateNotesOfGoalTypes } from '../redux/UpdateNotesOfGoalRedux';
import { UploadImageToGoalTypes } from '../redux/UploadImageToGoalRedux';
import { UploadFileTypes } from '../redux/UploadFileRedux';
import { UploadMakeTypes } from '../redux/UploadMakeRedux';
import { DeleteFileTypes } from '../redux/DeleteFileRedux';
import { DeleteMakeTypes } from '../redux/DeleteMakeRedux';
import { DeleteWithdrawalTypes } from '../redux/DeleteWithdrawalRedux';
import { DeleteLeaveTypes } from '../redux/DeleteLeaveRedux';
import { DeleteImageFromGoalTypes } from '../redux/DeleteImageFromGoalRedux';
import { UpdateProfilePicTypes } from '../redux/UpdateProfilePicRedux';
import { UpdateUserLocaleTypes } from '../redux/UpdateUserLocaleRedux';
import { UpdateMakeTypes } from '../redux/UpdateMakeRedux';
import { UpdateLeaveTypes } from '../redux/UpdateLeaveRedux';
import { CancelLeaveTypes } from '../redux/CancelLeaveRedux';
import { CancelMakeTypes } from '../redux/CancelMakeRedux';
import { ApplyLeaveTypes } from '../redux/ApplyLeaveRedux';
import { ApplyMakeTypes } from '../redux/ApplyMakeRedux';
import { ApplyWithdrawalTypes } from '../redux/ApplyWithdrawalRedux';
import { ChangePasswordTypes } from '../redux/ChangePasswordRedux';
import { GetMyAppointmentsTypes } from '../redux/GetMyAppointmentsRedux';
import { GetAppointmentCategoriesTypes } from '../redux/GetAppointmentCategoriesRedux';
import { GetAppointmentTimeslotsTypes } from '../redux/GetAppointmentTimeslotsRedux';
import { GetTimeslotsTypes } from '../redux/GetTimeslotsRedux';
import { GetTimeslotsThirtyDayTypes } from '../redux/GetTimeslotsThirtyDayRedux';
import { GetAppointmentTimeslotsNewTypes } from '../redux/GetAppointmentTimeslotsNewRedux';
import { GetLeaveTypes } from '../redux/GetLeaveRedux';
import { GetMakeTypes } from '../redux/GetMakeRedux';
import { GetFileTypes } from '../redux/GetFileRedux';
import { GetFileDownloadTypes } from '../redux/GetFileDownloadRedux';
import { GetWithdrawalTypes } from '../redux/GetWithdrawalRedux';
import { GetListLeaveTypes } from '../redux/GetListLeaveRedux';
import { GetListHistoryTypes } from '../redux/GetListHistoryRedux';
import { GetTypesTypes } from '../redux/GetTypesRedux';
import { GetLeavesCancelTypes } from '../redux/GetLeavesCancelRedux';
import { GetMakeUpSessionTypes } from '../redux/GetMakeUpSessionRedux';
import { GetCheckSickNoteTypes } from '../redux/GetCheckSickNoteRedux';
import { GetCheckAvailableTypes } from '../redux/GetCheckAvailableRedux';
import { GetLeavesMakeUpSessionTypes } from '../redux/GetLeavesMakeUpSessionRedux';
import { BookAppointmentTimeslotTypes } from '../redux/BookAppointmentTimeslotRedux';
import { SeenAnAnnouncementTypes } from '../redux/SeenAnAnnouncementRedux';
import { UpdateUserNotificationSettingsTypes } from '../redux/UpdateUserNotificationSettingsRedux';
import { UpdateNotificationTokenTypes } from '../redux/UpdateNotificationTokenRedux';
import { CreateMakeUpSessionTypes } from '../redux/CreateMakeUpSessionRedux';
import { CreateWithdrawalTypes } from '../redux/CreateWithdrawalRedux';
import { GalleryTypes } from '../redux/GalleryRedux';

import { login } from './LoginSagas';
import { register } from './RegisterSagas';
import { forgotPassword } from './ForgotPasswordSagas';
import { getChildren } from './GetChildrenSagas';
import { getMe } from './GetMeSagas';
import { logout } from './LogoutSagas';
import { attemptGoal } from './AttemptGoalSagas';
import { getCalendarEvents } from './GetCalendarEventsSagas';
import { getAnnouncements } from './GetAnnouncementsSagas';
import { AnnouncementIndividualTypes } from '../redux/AnnouncementIndividualRedux';
import announcementIndividualSaga from './AnnouncementIndividualSagas';
import { leave } from './LeaveSagas';
import { updatenotesofgoalsagas } from './UpdateNotesOfGoalSagas';
import { uploadimagetogoalsagas } from './UploadImageToGoalSagas';
import { uploadfilesagas } from './UploadFileSagas';
import { uploadmakesagas } from './UploadMakeSagas';
import { deletefilesagas } from './DeleteFileSagas';
import { deletemakesagas } from './DeleteMakeSagas';
import { deletewithdrawalsagas } from './DeleteWithdrawalSagas';
import { deleteleavesagas } from './DeleteLeaveSagas';
import { deleteimagefromgoalsagas } from './DeleteImageFromGoalSagas';
import { updateprofilepicsagas } from './UpdateProfilePicSagas';
import { updateuserlocalesagas } from './UpdateUserLocaleSagas';
import { updatemakesagas } from './UpdateMakeSagas';
import { updateleavesagas } from './UpdateLeaveSagas';
import { cancelleavesagas } from './CancelLeaveSagas';
import { cancelmakesagas } from './CancelMakeSagas';
import { applyleavesagas } from './ApplyLeaveSagas';
import { applymakesagas } from './ApplyMakeSagas';
import { applywithdrawalsagas } from './ApplyWithdrawalSagas';
import { changepasswordsagas } from './ChangePasswordSagas';
import { getMyAppointments } from './GetMyAppointmentsSagas';
import { getAppointmentCategories } from './GetAppointmentCategoriesSagas';
import { getAppointmentTimeslots } from './GetAppointmentTimeslotsSagas';
import { getTimeslots } from './GetTimeslotsSagas';
import { getTimeslotsThirtyDay } from './GetTimeslotsThirtyDaySagas';
import { getAppointmentTimeslotsNew } from './GetAppointmentTimeslotsNewSagas';
import { getleavesagas } from './GetLeaveSagas';
import { getmakesagas } from './GetMakeSagas';
import { getfilesagas } from './GetFileSagas';
import { getfiledownloadsagas } from './GetFileDownloadSagas';
import { getwithdrawalsagas } from './GetWithdrawalSagas';
import { getListLeaves } from './GetListLeaveSagas';
import { getlisthistorysagas } from './GetListHistorySagas';
import { gettypessagas } from './GetTypesSagas';
import { getleavescancelsagas } from './GetLeavesCancelSagas';
import { getmakeupsessionsagas } from './GetMakeUpSessionSagas';
import { getchecksicknotesagas } from './GetCheckSickNoteSagas';
import { getcheckavailablesagas } from './GetCheckAvailableSagas';
import { getLeavesMakeUpSession } from './GetLeavesMakeUpSessionSagas';
import { bookappointmenttimeslotsagas } from './BookAppointmentTimeslotSagas';
import seenAnAnnouncementSaga from './SeenAnAnnouncementSagas';
import { updateUserNotificationSettingsSagas } from './UpdateUserNotificationSettingsSagas';
import { updatenotificationtokensagas } from './UpdateNotificationTokenSagas';
import { createmakeupsessionsagas } from './CreateMakeUpSessionSagas';
import { createwithdrawalssagas } from './CreateWithdrawalsSagas';
import gallerySaga from './GallerySagas';

/* ------------- Connect Types To Sagas ------------- */

export default function* root(): Generator<any, void, any> {
  yield all([
    // Login sagas
    takeLatest(LoginTypes.LOGIN_REQUEST, login),
    
    // Register sagas
    takeLatest(RegisterTypes.REGISTER_REQUEST, register),
    
    // Forgot Password sagas
    takeLatest(ForgotPasswordTypes.FORGOT_PASSWORD_REQUEST, forgotPassword),
    
    // Get Children sagas
    takeLatest(GetChildrenTypes.GET_CHILDREN_REQUEST, getChildren),
    
    // Get Me sagas
    takeLatest(GetMeTypes.GET_ME_REQUEST, getMe),
    
    // Logout sagas
    takeLatest(LogoutTypes.LOGOUT_REQUEST, logout),
    
    // Attempt Goal sagas
    takeLatest(AttemptGoalTypes.ATTEMPT_GOAL_REQUEST, attemptGoal),
    
    // Get Calendar Events sagas
    takeLatest(GetCalendarEventsTypes.GET_CALENDAR_EVENTS_REQUEST, getCalendarEvents),
    
    // Get Announcements sagas
    takeLatest(GetAnnouncementsTypes.GET_ANNOUNCEMENTS_REQUEST, getAnnouncements),
    
    // Leave sagas
    takeLatest(LeaveTypes.LEAVE_REQUEST, leave),
    
    // Update Notes of Goal sagas
    takeLatest(UpdateNotesOfGoalTypes.UPDATE_NOTES_OF_GOAL_REQUEST, updatenotesofgoalsagas),
    
    // Upload Image to Goal sagas
    takeLatest(UploadImageToGoalTypes.UPLOAD_IMAGE_TO_GOAL_REQUEST, uploadimagetogoalsagas),
    
    // Upload File sagas
    takeLatest(UploadFileTypes.UPLOAD_FILE_REQUEST, uploadfilesagas),
    
    // Upload Make sagas
    takeLatest(UploadMakeTypes.UPLOAD_MAKE_REQUEST, uploadmakesagas),
    
    // Delete File sagas
    takeLatest(DeleteFileTypes.DELETE_FILE_REQUEST, deletefilesagas),
    
    // Delete Make sagas
    takeLatest(DeleteMakeTypes.DELETE_MAKE_REQUEST, deletemakesagas),
    
    // Delete Withdrawal sagas
    takeLatest(DeleteWithdrawalTypes.DELETE_WITHDRAWAL_REQUEST, deletewithdrawalsagas),
    
    // Delete Leave sagas
    takeLatest(DeleteLeaveTypes.DELETE_LEAVE_REQUEST, deleteleavesagas),
    
    // Delete Image from Goal sagas
    takeLatest(DeleteImageFromGoalTypes.DELETE_IMAGE_FROM_GOAL_REQUEST, deleteimagefromgoalsagas),
    
    // Update Profile Pic sagas
    takeLatest(UpdateProfilePicTypes.UPDATE_PROFILE_PIC_REQUEST, updateprofilepicsagas),
    
    // Update User Locale sagas
    takeLatest(UpdateUserLocaleTypes.UPDATE_USER_LOCALE_REQUEST, updateuserlocalesagas),
    
    // Update Make sagas
    takeLatest(UpdateMakeTypes.UPDATE_MAKE_REQUEST, updatemakesagas),
    
    // Update Leave sagas
    takeLatest(UpdateLeaveTypes.UPDATE_LEAVE_REQUEST, updateleavesagas),
    
    // Cancel Leave sagas
    takeLatest(CancelLeaveTypes.CANCEL_LEAVE_REQUEST, cancelleavesagas),
    
    // Cancel Make sagas
    takeLatest(CancelMakeTypes.CANCEL_MAKE_REQUEST, cancelmakesagas),
    
    // Apply Leave sagas
    takeLatest(ApplyLeaveTypes.APPLY_LEAVE_REQUEST, applyleavesagas),
    
    // Apply Make sagas
    takeLatest(ApplyMakeTypes.APPLY_MAKE_REQUEST, applymakesagas),
    
    // Apply Withdrawal sagas
    takeLatest(ApplyWithdrawalTypes.APPLY_WITHDRAWAL_REQUEST, applywithdrawalsagas),
    
    // Change Password sagas
    takeLatest(ChangePasswordTypes.CHANGE_PASSWORD_REQUEST, changepasswordsagas),
    
    // Get My Appointments sagas
    takeLatest(GetMyAppointmentsTypes.GET_MY_APPOINTMENTS_REQUEST, getMyAppointments),
    
    // Get Appointment Categories sagas
    takeLatest(GetAppointmentCategoriesTypes.GET_APPOINTMENT_CATEGORIES_REQUEST, getAppointmentCategories),
    
    // Get Appointment Timeslots sagas
    takeLatest(GetAppointmentTimeslotsTypes.GET_APPOINTMENT_TIMESLOTS_REQUEST, getAppointmentTimeslots),
    
    // Get Timeslots sagas
    takeLatest(GetTimeslotsTypes.GET_TIMESLOTS_REQUEST, getTimeslots),
    
    // Get Timeslots Thirty Day sagas
    takeLatest(GetTimeslotsThirtyDayTypes.GET_TIMESLOTS_THIRTY_DAY_REQUEST, getTimeslotsThirtyDay),
    
    // Get Appointment Timeslots New sagas
    takeLatest(GetAppointmentTimeslotsNewTypes.GET_APPOINTMENT_TIMESLOTS_NEW_REQUEST, getAppointmentTimeslotsNew),
    
    // Get Leave sagas
    takeLatest(GetLeaveTypes.GET_LEAVE_REQUEST, getleavesagas),
    
    // Get Make sagas
    takeLatest(GetMakeTypes.GET_MAKE_REQUEST, getmakesagas),
    
    // Get File sagas
    takeLatest(GetFileTypes.GET_FILE_REQUEST, getfilesagas),
    
    // Get File Download sagas
    takeLatest(GetFileDownloadTypes.GET_FILE_DOWNLOAD_REQUEST, getfiledownloadsagas),
    
    // Get Withdrawal sagas
    takeLatest(GetWithdrawalTypes.GET_WITHDRAWAL_REQUEST, getwithdrawalsagas),
    
    // Get List Leave sagas
    takeLatest(GetListLeaveTypes.GET_LIST_LEAVE_REQUEST, getListLeaves),
    
    // Get List History sagas
    takeLatest(GetListHistoryTypes.GET_LIST_HISTORY_REQUEST, getlisthistorysagas),
    
    // Get Types sagas
    takeLatest(GetTypesTypes.GET_TYPES_REQUEST, gettypessagas),
    
    // Get Leaves Cancel sagas
    takeLatest(GetLeavesCancelTypes.GET_LEAVES_CANCEL_REQUEST, getleavescancelsagas),
    
    // Get Make Up Session sagas
    takeLatest(GetMakeUpSessionTypes.GET_MAKE_UP_SESSION_REQUEST, getmakeupsessionsagas),
    
    // Get Check Sick Note sagas
    takeLatest(GetCheckSickNoteTypes.GET_CHECK_SICK_NOTE_REQUEST, getchecksicknotesagas),
    
    // Get Check Available sagas
    takeLatest(GetCheckAvailableTypes.GET_CHECK_AVAILABLE_REQUEST, getcheckavailablesagas),
    
    // Get Leaves Make Up Session sagas
    takeLatest(GetLeavesMakeUpSessionTypes.GET_LEAVES_MAKE_UP_SESSION_REQUEST, getLeavesMakeUpSession),
    
    // Book Appointment Timeslot sagas
    takeLatest(BookAppointmentTimeslotTypes.BOOK_APPOINTMENT_TIMESLOT_REQUEST, bookappointmenttimeslotsagas),
    
    // Seen An Announcement sagas
    takeLatest(SeenAnAnnouncementTypes.SEEN_AN_ANNOUNCEMENT_REQUEST, seenAnAnnouncementSaga),
    
    // Announcement Individual sagas
    takeLatest(AnnouncementIndividualTypes.GET_ANNOUNCEMENT_INDIVIDUAL_REQUEST, announcementIndividualSaga),
    
    // Update User Notification Settings sagas
    takeLatest(UpdateUserNotificationSettingsTypes.UPDATE_USER_NOTIFICATION_SETTINGS_REQUEST, updateUserNotificationSettingsSagas),
    
    // Update Notification Token sagas
    takeLatest(UpdateNotificationTokenTypes.UPDATE_NOTIFICATION_TOKEN_REQUEST, updatenotificationtokensagas),
    
    // Create Make Up Session sagas
    takeLatest(CreateMakeUpSessionTypes.CREATE_MAKE_UP_SESSION_REQUEST, createmakeupsessionsagas),
    
    // Create Withdrawals sagas
    takeLatest(CreateWithdrawalTypes.CREATE_WITHDRAWALS_REQUEST, createwithdrawalssagas),
    
    // Gallery sagas
    takeLatest(GalleryTypes.LOAD_GALLERY_REQUEST, gallerySaga),
    takeLatest(GalleryTypes.UPLOAD_IMAGE_REQUEST, gallerySaga),
    takeLatest(GalleryTypes.DELETE_IMAGE_REQUEST, gallerySaga),
    takeLatest(GalleryTypes.TOGGLE_FAVORITE, gallerySaga),
  ]);
}
